import { post } from 'helpers/api';

import TagsApi from 'bundles/tags/tags_api';
import { retrieveRecords } from './search';
import { noFiltersApplied } from '../selectors/query';
import { initialState } from 'bundles/research/index/research_constants';
import { merge } from 'lodash';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return { type: CLEAR_FILTERS };
}

export const CHANGE_ADDRESS_FILTER_GROUP = 'CHANGE_ADDRESS_FILTER_GROUP';
export function changeAddressFilterGroup(addressFilter) {
  return { addressFilter: addressFilter, type: CHANGE_ADDRESS_FILTER_GROUP };
}

export const CHANGE_INDUSTRIAL_FILTER_GROUP = 'CHANGE_INDUSTRIAL_FILTER_GROUP';
export function changeIndustrialFilterGroup(industrialFilter) {
  return { industrialFilter: industrialFilter, type: CHANGE_INDUSTRIAL_FILTER_GROUP };
}

export const CHANGE_MULTIFAMILY_FILTER_GROUP = 'CHANGE_MULTIFAMILY_FILTER_GROUP';
export function changeMultifamilyFilterGroup(multifamilyFilter) {
  return { multifamilyFilter: multifamilyFilter, type: CHANGE_MULTIFAMILY_FILTER_GROUP };
}

export const CHANGE_PROPERTY_PAGE = 'CHANGE_PROPERTY_PAGE';
export function changePropertyPage(page) {
  post('/research/properties/set_page', { propertyPage: page });
  return { page: page, type: CHANGE_PROPERTY_PAGE };
}

export const CHANGE_PROPERTY_FILTER_GROUP = 'CHANGE_PROPERTY_FILTER_GROUP';
export function changePropertyFilterGroup(propertyFilter) {
  return { propertyFilter: propertyFilter, type: CHANGE_PROPERTY_FILTER_GROUP };
}

export const CHANGE_SALE_FILTER_GROUP = 'CHANGE_SALE_FILTER_GROUP';
export function changeSaleFilterGroup(saleFilter) {
  return { saleFilter: saleFilter, type: CHANGE_SALE_FILTER_GROUP };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(value) {
  return { value: value, type: CHANGE_SEARCH_TEXT };
}

export const SET_FULL_QUERY = 'SET_FULL_QUERY';
export const setFullQuery = query => (
  (dispatch) => {
    const newQueryState = merge({}, initialState, query);
    dispatch({ type: SET_FULL_QUERY, query: newQueryState });
  }
);

export const SELECT_AVAILABILITY = 'SELECT_AVAILABILITY';
export function selectAvailability(key, value) {
  return { id: key, value: value, type: SELECT_AVAILABILITY };
}

export const SELECT_ASSET_CLASS = 'SELECT_ASSET_CLASS';
export function selectAssetClass(key, value) {
  return { role: key, value: value, type: SELECT_ASSET_CLASS };
}

export const SELECT_BUILDING_CLASS = 'SELECT_BUILDING_CLASS';
export function selectBuildingClass(key, value) {
  return { role: key, value: value, type: SELECT_BUILDING_CLASS };
}

export const SELECT_INVESTMENT_TYPE = 'SELECT_INVESTMENT_TYPE';
export function selectInvestmentType(key, value) {
  return { role: key, value: value, type: SELECT_INVESTMENT_TYPE };
}

export const SET_GROUP_FILTER_IDS = 'SET_GROUP_FILTER_IDS';
export function setGroupFilterIds(groupIds) {
  return { groupIds, type: SET_GROUP_FILTER_IDS };
}

export const ADD_GROUP_FILTER_ID = 'ADD_GROUP_FILTER_ID';
export function addGroupFilterId(groupId) {
  return { groupId, type: ADD_GROUP_FILTER_ID };
}

export const REMOVE_GROUP_FILTER_ID = 'REMOVE_GROUP_FILTER_ID';
export function removeGroupFilterId(groupId) {
  return { groupId, type: REMOVE_GROUP_FILTER_ID };
}

export const SET_ASSOCIATION_FILTERS = 'SET_ASSOCIATION_FILTERS';
export function setAssociationFilters(associationFilters) {
  return { type: SET_ASSOCIATION_FILTERS, associationFilters };
}

export const SET_ASSOCIATION_FILTER = 'SET_ASSOCIATION_FILTER';
export function setAssociationFilter(key, value) {
  return (dispatch) => {
    dispatch({ type: SET_ASSOCIATION_FILTER, key, value });
    dispatch(retrieveRecords());
  };
}

export const SET_AVAILABILITIES = 'SET_AVAILABILITIES';
export function setAvailabilities(availabilities) {
  return { availabilities: availabilities, type: SET_AVAILABILITIES };
}

export const SET_ASSET_CLASSES = 'SET_ASSET_CLASSES';
export function setAssetClasses(assetClasses) {
  return { assetClasses: assetClasses, type: SET_ASSET_CLASSES };
}

export const SET_BUILDING_CLASSES = 'SET_BUILDING_CLASSES';
export function setBuildingClasses(buildingClasses) {
  return { buildingClasses: buildingClasses, type: SET_BUILDING_CLASSES };
}

export const SET_INVESTMENT_TYPES = 'SET_INVESTMENT_TYPES';
export function setInvestmentTypes(investmentTypes) {
  return { investmentTypes, type: SET_INVESTMENT_TYPES };
}

export const SELECT_EXCLUDE_TAGS = 'SELECT_EXCLUDE_TAGS';
export function selectExcludeTags() {
  return { type: SELECT_EXCLUDE_TAGS };
}

export const SET_TAGS = 'SET_TAGS';
export function setTags(tags) {
  return { tags: tags, type: SET_TAGS };
}

export const CHANGE_SORT = 'CHANGE_SORT';
export function changeSort(sort) {
  return { sort: sort, type: CHANGE_SORT };
}


export function clearFiltersIfEmpty() {
  return (dispatch, getState) => {
    if (noFiltersApplied(getState())) {
      dispatch(clearFilters());
    }
  };
}

export function getTags(tagNames) {
  return (dispatch, getState) => {
    if (tagNames.length > 0) {
      const { paths: { tags } } = getState();
      const api = new TagsApi(tags);
      api.searchTags('', tagNames).then((tags) => {
        dispatch(setTags(tags));
        dispatch(retrieveRecords());
      });
    }
  };
}
